import {create} from 'zustand';
import {MobileErrorModalStore} from './types';

export const useMobileErrorModalStore = create<MobileErrorModalStore>(set => ({
	errorModal: false,
	setErrorModal: value => set({errorModal: value}),
}));
